/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { TreeSelect as AntTreeSelect } from 'grab-ui';

class MultipleSelect extends Component {
  constructor(props) {
    super(props);
    const { defaultValue } = this.props;
    this.state = {
      selectedValues: defaultValue || [],
    };
  }

  onSelectAll = () => {
    const { onSelectionChange } = this.props;
    const allValues = this.getAllValues();
    this.setState({
      selectedValues: allValues,
    });
    onSelectionChange(allValues);
  };

  onUnSelectAll = () => {
    const { mustSelectValue, onSelectionChange } = this.props;
    this.setState({
      selectedValues: mustSelectValue,
    });
    onSelectionChange(mustSelectValue);
  };

  onSelectionChange = values => {
    const { onSelectionChange } = this.props;
    onSelectionChange(values);
    this.setState({
      selectedValues: values,
    });
  };

  getAllValues = () => {
    const { options } = this.props;
    return options.map(o => o.value);
  };

  render() {
    const { selectedValues } = this.state;
    const { options, placeholder } = this.props;
    const selectedAll = selectedValues.length === options.length;
    const selectedNone = selectedValues.length === 0;
    const treeData = [
      {
        title: (
          <Fragment>
            <span
              role="button"
              onKeyDown={null}
              onClick={() => (selectedAll ? null : this.onSelectAll())}
              style={{
                display: 'inline-block',
                cursor: selectedAll ? 'not-allowed' : 'pointer',
                color: selectedAll ? '#D3D3D3' : '#000',
                marginRight: '5px',
              }}
            >
              Select all
            </span>
            <span
              role="button"
              onKeyDown={null}
              onClick={() => (selectedNone ? null : this.onUnSelectAll())}
              style={{
                display: 'inline-block',
                cursor: selectedNone ? 'not-allowed' : 'pointer',
                color: selectedNone ? '#D3D3D3' : '#000',
              }}
            >
              Unselect all
            </span>
          </Fragment>
        ),
        value: 'xxx',
        disableCheckbox: true,
        disabled: true,
        selectable: false,
      },
      ...options,
    ];

    return (
      <AntTreeSelect
        prefix="Select columns to show"
        allowClear
        placeholder={placeholder}
        treeCheckable
        showCheckedStrategy={AntTreeSelect.SHOW_CHILD}
        onChange={this.onSelectionChange}
        value={selectedValues}
        // Enable for not showing selected tags
        // maxTagCount={0}
        // maxTagPlaceholder={omittedValues => placeholder}
        treeData={treeData}
      />
    );
  }
}

MultipleSelect.propTypes = {
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.arrayOf(PropTypes.string).isRequired,
  // values that are always selected
  mustSelectValue: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default MultipleSelect;
